import {inject, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {SystemEvent} from '../../system-event/classes/system-event';
import {State} from '../../outage/classes/state';
import {Moment} from 'moment';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import {SitRepFilters} from '../classes/sit-rep-filters';
import {BaseElement} from '../classes/base-element';
import {ElementOptionsConfig} from '../classes/element-option';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {ExportComponents} from '../../../enums/export-components.enum';
import {MatSnackBar} from '@angular/material/snack-bar';
import moment from 'moment/moment';

export interface ComponentExportConfig {
    component: ExportComponents;
    tz?: string;
    filename?: string;
    height?: number;
    width?: number;
    inputs?: {[key: string]: any};
}

@Injectable({
    providedIn: 'root',
})
export class SitRepService {
    private filters$$ = new BehaviorSubject<SitRepFilters>(new SitRepFilters());
    public sitRepFilters: Signal<SitRepFilters> = toSignal(this.filters$$);
    private snackBar = inject(MatSnackBar);

    public openedConfigOptions: WritableSignal<ElementOptionsConfig | null> = signal(null);
    private openedElement: BaseElement | null = null;

    public requestComponentConfig = new Subject();

    private http = inject(HttpClient);

    public updateFilters(filters: {
        event?: SystemEvent | null;
        locations?: State[];
        startDate?: Moment | null;
        endDate?: Moment | null;
    }): void {
        this.filters$$.next({...this.filters$$.value, ...filters});
    }

    public openConfigSideBar(element: BaseElement, options: ElementOptionsConfig) {
        // Remove selected if another element was selected before
        if (!!this.openedElement) {
            this.openedElement.configureSelected = false;
        }

        this.openedConfigOptions.set({...options});
        this.openedElement = element;
        this.openedElement.configureSelected = true;
    }

    public closeConfigSideBar(updateElement: boolean) {
        if (updateElement) {
            this.openedElement.updateConfigValues(this.openedConfigOptions());
        }

        this.openedConfigOptions.set(null);
        this.openedElement.configureSelected = false;
        this.openedElement = null;
    }

    public exportComponent(body: ComponentExportConfig[]): Observable<string> {
        const url = `api/systemdata/export-component`;

        let loadingMessage = `Generating Image`;
        loadingMessage += body.length > 1 ? `s` : '';

        const ref = this.snackBar.open(loadingMessage, 'X');

        const timeZone = moment.tz.guess();
        body.forEach((item) => {
            item.tz = item.tz || timeZone;
        });

        return this.http.post(url, body, {responseType: 'blob'}).pipe(
            tap({
                next: () => ref.dismiss(),
                error: (e) => {
                    ref.dismiss();
                    this.snackBar.open('Error while exporting Image', 'X', {panelClass: 'dialog-failure', duration: 3_000});
                },
            }),
            map((blob) => {
                return window.URL.createObjectURL(blob);
            })
        );
    }
}
